function replaceSerbianChars(text) {
    const replacements = {
      Č: "C", č: "c", Ć: "C", ć: "c", š: "s", Š: "S",
      đ: "dj", Đ: "Dj", ž: "z", Ž: "Z",
    }
    return text.replace(/[\u0106\u0107\u0161\u0160\u0111\u0110\u010C\u010D\u017D\u017E]/g, (char) => replacements[char] || char)
}

export {
    replaceSerbianChars
}